import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DiscoverFacade } from '@zero/discover/domain';
import { filter, map } from 'rxjs';
import { DiscoverCardType } from '../../utils/discover-card-type.enum';
import { DiscoverArticleComponent } from '../discover-article/discover-article.component';
import { DiscoverKnowHowComponent } from '../discover-know-how/discover-know-how.component';
import { DiscoverLatestComponent } from '../discover-latest/discover-latest.component';
import { DiscoverMegatrendsComponent } from '../discover-megatrends/discover-megatrends.component';
import { DiscoverMoreComponent } from '../discover-more/discover-more.component';
import { DiscoverNavComponent } from '../discover-nav/discover-nav.component';

@Component({
  selector: 'discover-card',
  imports: [
    CommonModule,
    TranslocoPipe,
    DiscoverLatestComponent,
    DiscoverMegatrendsComponent,
    DiscoverKnowHowComponent,
    DiscoverMoreComponent,
    DiscoverNavComponent,
    DiscoverArticleComponent,
  ],
  templateUrl: './discover-card.component.html',
})
export class DiscoverCardComponent implements OnInit, AfterViewInit {
  @ViewChild('modal') public modal?: TemplateRef<HTMLElement>;

  public readonly facade = inject(DiscoverFacade);
  public readonly DiscoverCardType = DiscoverCardType;
  readonly #ngbModal = inject(NgbModal);
  readonly #route = inject(ActivatedRoute);

  public cardType = DiscoverCardType.Latest;

  ngOnInit(): void {
    this.facade.loadDiscoverOverview();
  }

  ngAfterViewInit(): void {
    this.#route.queryParams
      .pipe(
        map(({ discoverArticleId, discoverType }) => ({
          id: discoverArticleId,
          type: discoverType as DiscoverCardType,
        })),
        filter(({ id, type }) => !!id && !!type),
      )
      .subscribe(({ id, type }) => this.openDetails(id, type));
  }

  public openDetails(id: string, type: DiscoverCardType): void {
    switch (type) {
      case DiscoverCardType.Megatrends:
        this.facade.loadDiscoverMegatrendsDetails(id);
        break;
      case DiscoverCardType.KnowHow:
        this.facade.loadDiscoverKnowHowDetails(id);
        break;
      case DiscoverCardType.More:
        this.facade.loadDiscoverListAndLinksDetails(id);
        break;
      case DiscoverCardType.Latest:
        this.facade.loadDiscoverTodayDetails(id);
        break;
      default:
        return;
    }
    this.#ngbModal.open(this.modal, { size: 'xl', centered: true });
  }
}
